<template>
    <LsModal :title="title" track-id="flow_success_modal">
        <template #body>
            <LsCopyContent :text="copy" />

            <!-- TODO: this should have some sort of loading state or animation -->
            <div v-if="servicesOnDate.length - exclude.length > 0">
                <p test-id="display_date" class="ls-flow-success-modal--other-services-date">
                    Other services that are currently scheduled for {{ dateRange }}
                </p>
                <LsServiceList :services="servicesOnDate" :exclude="exclude" @click="handleClick" />
            </div>
        </template>
        <template #footer>
            <LsButton
                text="Back to Dashboard"
                track-id="flow_success_modal-close"
                outlined
                text-color="primary"
                @click="close"
            />
            <LsButton
                v-if="showAddServiceButton"
                class="ls-flow-success-modal--add-service"
                text="Add Service"
                track-id="flow_success_modal-add_service"
                test-id="add-service"
                outlined
                text-color="primary"
                @click="addService"
            />
        </template>
    </LsModal>
</template>

<script>
import VueTypes from 'vue-types';
import { lsErrorService, lsPropTypeHelpers } from 'ls-vue-common';
import _ from 'lodash';
import { LsModal, LsButton, LsCopyContent } from '@/components/common';
import LsServiceList from '@/components/LsServiceList/LsServiceList.vue';
import { lsHelpers } from '@/helpers';
import AllServicesOnDate from '@/graphql/queries/AllServicesOnDate.gql';

export default {
    name: 'FlowSuccessModal',
    components: {
        LsModal,
        LsButton,
        LsCopyContent,
        LsServiceList,
    },
    props: {
        title: VueTypes.string.isRequired,
        copy: VueTypes.string.isRequired,
        replaceRoute: VueTypes.bool.def(false),
        showAddServiceButton: VueTypes.bool.def(false),
        displayServicesOnDate: VueTypes.shape({
            next_customer_starts_at: VueTypes.string.isRequired,
            next_customer_ends_at: VueTypes.string.isRequired,
        }),
        routeOverride: VueTypes.custom(lsPropTypeHelpers.functionOrNull).def(null),
    },
    data() {
        return {
            servicesOnDate: [],
        };
    },
    apollo: {
        allServicesOnDate: {
            query: AllServicesOnDate,
            variables() {
                return {
                    customer_id: _.toNumber(this.$route.params.customer_id),
                    property_id: _.toNumber(this.$route.params.property_id),
                    date: this.displayServicesOnDate.next_customer_starts_at,
                };
            },
            skip() {
                return !this.displayServicesOnDate;
            },
            result({ data, loading }) {
                if (!loading) {
                    const { schedules, recommendations, requiredServices } = data.allServicesOnDate;
                    this.servicesOnDate = [...schedules, ...recommendations, ...requiredServices];
                }
            },
            error(error) {
                lsErrorService.log({ error });
            },
        },
    },
    computed: {
        dateRange() {
            return lsHelpers.dateRange({
                start: this.displayServicesOnDate.next_customer_starts_at,
                end: this.displayServicesOnDate.next_customer_ends_at,
            });
        },
        oldAdminMeta() {
            return this.$route.meta.oldAdminWithOutAuth;
        },
        exclude() {
            // TODO: this will need to be updated to support rec/req
            if (this.$route.params.schedule_id) {
                return [
                    {
                        __typename: 'Schedule',
                        id: _.toString(this.$route.params.schedule_id),
                    },
                ];
            } else {
                return [];
            }
        },
    },
    created() {
        if (this.routeOverride) {
            return this.routeOverride();
        }

        lsHelpers.goToParentView({ replace: this.replaceRoute });
    },
    methods: {
        close() {
            this.$parent.close();
        },
        addService() {
            window.location.assign(`${process.env.VUE_APP_ADMIN_BASE_URL}/${this.oldAdminMeta}`);
        },
        handleClick({ id }) {
            //TODO: update to support rec / reqs
            this.$router.push({
                name: 'schedule',
                params: {
                    customer_id: this.$route.params.customer_id,
                    property_id: this.$route.params.property_id,
                    schedule_id: id,
                },
            });
            this.$parent.close();
        },
    },
};
</script>

<style lang="scss">
.ls-flow-success-modal--other-services-date {
    border-top: 1px solid $secondary-light;
    margin: 20px 0;
    padding-top: 20px;
    font-weight: $semi-bold;
    color: $secondary-dark;
}

.ls-flow-success-modal--add-service {
    margin-left: 10px;
}
</style>
